var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImpactClaimPlaceholder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00004 13.5455C10.615 13.5455 13.5455 10.615 13.5455 7.00004C13.5455 3.38509 10.615 0.45459 7.00004 0.45459C3.38509 0.45459 0.45459 3.38509 0.45459 7.00004C0.45459 10.615 3.38509 13.5455 7.00004 13.5455ZM8.91955 4.46685C9.11112 4.28173 9.41418 4.27931 9.60867 4.46134L10.298 5.10651C10.5068 5.30194 10.5095 5.63237 10.3038 5.83111L6.47021 9.53575C6.2797 9.71985 5.97867 9.7234 5.78388 9.54384L3.70479 7.62741C3.49451 7.43358 3.48935 7.10318 3.69349 6.90288L4.36576 6.24324C4.55591 6.05666 4.85894 6.05193 5.05482 6.23248L5.75072 6.87393C5.94551 7.05348 6.24655 7.04993 6.43705 6.86584L8.91955 4.46685Z",
    fill: "#B2BCEB"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImpactClaimPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/impact-claim-placeholder.67dacae4d71764b0edb1c39f5e71ac5b.svg";